import EventStats from '@/screens/EventStats';

export default function PrivateTabsOrganizationEventEventIdStatsRoute() {
  return <EventStats />;
}
